import React from "react";
import { SnackbarContext } from "../contexts/Snackbar";
import { snackbarSeverity } from "./useSnackbar";
import api from "../utils/api/authApi";

export default function useFileDownload(url, urlId) {
  const { handleSnackbar } = React.useContext(SnackbarContext);

  async function downloadDoctorsLetter() {
    downloadFile(`doctorsLetter.pdf`)
  }

  async function downloadInvoice(id) {
    downloadFile(`invoice.pdf`, id)
  }

  async function downloadFile(fileName, id) {
    const paramId = id ? id : urlId
    try {
      const response = await api.get(url + paramId, {
        responseType: "blob",
      });

      if (response.status === 200) {
        const blob = response.data;
        const downloadUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", fileName);

        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);

      }
    } catch (e) {
      handleSnackbar(e?.response?.data, snackbarSeverity.ERROR);
    }
  }

  return {
    downloadDoctorsLetter,
    downloadInvoice
  };
}
